export default __webpack_public_path__ + "static/media/sinatra.9455f83b.svg";